/* Consistent Derma — theme.js
   Cart drawer (AJAX + Section Rendering API), add-to-cart, PDP gallery/variants,
   concern tabs, collection filter, accordion, and GoKwik-aware checkout. */
(function () {
  'use strict';

  var CD = (window.CD = window.CD || {});
  CD.routes = CD.routes || { root: '/', cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change' };
  CD.gokwik = CD.gokwik || { enabled: false };
  CD.settings = CD.settings || {};

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var isMobile = function () { return window.matchMedia('(max-width: 749px)').matches; };

  /* ------------------------------------------------------------------ */
  /* Money                                                               */
  /* ------------------------------------------------------------------ */
  CD.formatMoney = function (cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = parseInt(cents, 10) || 0;
    format = format || CD.moneyFormat || '₹{{amount}}';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;

    function withDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ',';
      decimal = decimal || '.';
      var fixed = (number / 100).toFixed(precision);
      var parts = fixed.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var c = parts[1] ? decimal + parts[1] : '';
      return dollars + c;
    }

    var match = format.match(placeholder);
    var value = '';
    switch (match ? match[1] : 'amount') {
      case 'amount': value = withDelimiters(cents, 2); break;
      case 'amount_no_decimals': value = withDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
      case 'amount_no_decimals_with_space_separator': value = withDelimiters(cents, 0, ' ', ''); break;
      case 'amount_with_space_separator': value = withDelimiters(cents, 2, ' ', ','); break;
      case 'amount_with_period_and_space_separator': value = withDelimiters(cents, 2, ' ', '.'); break;
      default: value = withDelimiters(cents, 2);
    }
    // mirror Liquid's money_without_trailing_zeros
    value = value.replace(/[.,]00$/, '');
    var out = format.replace(placeholder, value);
    var tmp = document.createElement('div');
    tmp.innerHTML = out;
    return tmp.textContent || out;
  };

  /* ------------------------------------------------------------------ */
  /* Cart                                                                */
  /* ------------------------------------------------------------------ */
  var drawer = function () { return $('[data-cart-drawer]'); };

  function sectionIds() {
    var ids = [];
    if (drawer()) ids.push('cart-drawer');
    var page = $('[data-cart-page]');
    if (page && page.dataset.sectionId) ids.push(page.dataset.sectionId);
    return ids;
  }

  function parseHTML(html) {
    return new DOMParser().parseFromString(html, 'text/html');
  }

  function renderSections(sections) {
    if (!sections) return;
    Object.keys(sections).forEach(function (id) {
      var html = sections[id];
      if (!html) return;
      var doc = parseHTML(html);
      if (id === 'cart-drawer') {
        var fresh = $('[data-cart-drawer-inner]', doc);
        var current = $('[data-cart-drawer-inner]');
        if (fresh && current) current.innerHTML = fresh.innerHTML;
      } else {
        var wrap = document.getElementById('shopify-section-' + id);
        var freshSection = $('[data-cart-page]', doc);
        var currentSection = wrap ? $('[data-cart-page]', wrap) : null;
        if (freshSection && currentSection) currentSection.innerHTML = freshSection.innerHTML;
      }
    });
  }

  function updateCount(count) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = count; });
  }

  function setCart(cart) {
    if (!cart) return;
    CD.cart = cart;
    updateCount(cart.item_count);
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
    // Some GoKwik builds read these globals
    window.cart = cart;
  }

  function fetchJSON(url, opts) {
    return fetch(url, opts).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok || data.status) {
          var err = new Error(data.description || data.message || 'Cart error');
          err.data = data;
          throw err;
        }
        return data;
      });
    });
  }

  CD.getCart = function () {
    return fetchJSON(CD.routes.root.replace(/\/$/, '') + '/cart.js', { headers: { Accept: 'application/json' } }).then(function (cart) {
      setCart(cart);
      return cart;
    });
  };

  CD.addItems = function (items) {
    var ids = sectionIds();
    return fetchJSON(CD.routes.cartAdd + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items, sections: ids, sections_url: window.location.pathname })
    }).then(function (res) {
      renderSections(res.sections);
      return CD.getCart();
    });
  };

  CD.changeLine = function (line, quantity) {
    var ids = sectionIds();
    return fetchJSON(CD.routes.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity, sections: ids, sections_url: window.location.pathname })
    }).then(function (cart) {
      renderSections(cart.sections);
      setCart(cart);
      return cart;
    });
  };

  /* Drawer open / close */
  var lastFocus = null;
  CD.openCart = function () {
    var d = drawer();
    if (!d) { window.location.href = CD.routes.cart; return; }
    lastFocus = document.activeElement;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('has-drawer-open');
    var panel = $('.cart-drawer__panel', d);
    if (panel) setTimeout(function () { panel.focus(); }, 50);
  };
  CD.closeCart = function () {
    var d = drawer();
    if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('has-drawer-open');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  };

  /* ------------------------------------------------------------------ */
  /* Checkout (GoKwik aware)                                             */
  /* ------------------------------------------------------------------ */
  function showLoader() {
    var l = $('[data-checkout-loader]');
    if (l) l.hidden = false;
  }
  window.addEventListener('pageshow', function () {
    var l = $('[data-checkout-loader]');
    if (l) l.hidden = true;
  });

  function gokwikHandler() {
    return CD.gokwik && CD.gokwik.enabled && typeof window.onCheckoutClick === 'function' ? window.onCheckoutClick : null;
  }

  // Route the shopper to checkout from anywhere (Buy Now, sticky bars, etc.)
  CD.checkout = function (sourceBtn) {
    var handler = gokwikHandler();
    if (handler) {
      try { handler(sourceBtn || $('[data-checkout]')); return; } catch (e) { console.error('[GoKwik]', e); }
    }
    // Click the real checkout button so any app-embed interceptor (GoKwik app) can take over.
    var btn = $('[data-cart-drawer] [data-checkout]') || $('[data-cart-page] [data-checkout]');
    if (btn && !btn.disabled) { btn.click(); return; }
    showLoader();
    window.location.href = CD.routes.root.replace(/\/$/, '') + '/checkout';
  };

  /* ------------------------------------------------------------------ */
  /* Button state helpers                                                */
  /* ------------------------------------------------------------------ */
  function markAdded(btn) {
    if (!btn) return;
    btn.classList.add('is-added');
    var label = btn.dataset.labelAdded;
    if (isMobile() && btn.dataset.labelAddedMobile) label = btn.dataset.labelAddedMobile;
    if (!label) return;
    var target = $('.hide-mobile', btn) && $('.show-mobile', btn) ? null : btn;
    if (target) target.textContent = label;
    else { $('.hide-mobile', btn).textContent = label; $('.show-mobile', btn).textContent = label; }
  }

  function syncAddedStates() {
    var cart = CD.cart;
    if (!cart || !cart.items) return;
    var inCart = {};
    cart.items.forEach(function (i) { inCart[String(i.variant_id)] = true; });
    $$('[data-add-to-cart][data-variant-id]').forEach(function (btn) {
      if (inCart[btn.dataset.variantId] && !btn.classList.contains('is-added')) markAdded(btn);
    });
  }

  /* ------------------------------------------------------------------ */
  /* Global click delegation                                             */
  /* ------------------------------------------------------------------ */
  document.addEventListener('click', function (e) {
    var t = e.target;

    // Cart toggle
    var toggle = t.closest('[data-cart-toggle]');
    if (toggle && drawer() && CD.settings.cartType !== 'page') {
      e.preventDefault();
      CD.openCart();
      return;
    }
    if (t.closest('[data-cart-close]')) { e.preventDefault(); CD.closeCart(); return; }

    // Checkout button inside cart drawer / page
    var checkoutBtn = t.closest('[data-checkout]');
    if (checkoutBtn) {
      var handler = gokwikHandler();
      if (handler) {
        e.preventDefault();
        try { handler(checkoutBtn); } catch (err) { console.error('[GoKwik]', err); checkoutBtn.form && checkoutBtn.form.submit(); }
        return;
      }
      // Native submit continues (POST /cart -> checkout). If the GoKwik app embed is
      // active it intercepts this click itself, so no loader is shown in that case.
      if (!CD.gokwik.enabled && !e.defaultPrevented) showLoader();
      return;
    }

    // Quick add (cards, concern routines, upsells, spotlight)
    var addBtn = t.closest('[data-add-to-cart]');
    if (addBtn) {
      e.preventDefault();
      if (addBtn.disabled) return;
      var ids = (addBtn.dataset.variantIds || addBtn.dataset.variantId || '').split(',').filter(Boolean);
      if (!ids.length) return;
      addBtn.disabled = true;
      addBtn.classList.add('is-loading');
      CD.addItems(ids.map(function (id) { return { id: Number(id), quantity: 1 }; }))
        .then(function () {
          markAdded(addBtn);
          if (CD.settings.openDrawerOnAdd) CD.openCart();
        })
        .catch(function (err) { alert(err.message || (CD.strings && CD.strings.error)); })
        .then(function () { addBtn.disabled = false; addBtn.classList.remove('is-loading'); });
      return;
    }

    // Cart line quantity / remove
    var qtyBtn = t.closest('[data-cart-qty]');
    if (qtyBtn) {
      e.preventDefault();
      var line = Number(qtyBtn.dataset.line);
      var q = Math.max(0, Number(qtyBtn.dataset.cartQty));
      var row = qtyBtn.closest('[data-cart-line]');
      if (row) row.classList.add('is-updating');
      CD.changeLine(line, q).catch(function (err) {
        if (row) row.classList.remove('is-updating');
        alert(err.message || (CD.strings && CD.strings.error));
      });
      return;
    }

    // Search
    if (t.closest('[data-search-toggle]')) {
      e.preventDefault();
      var panel = $('[data-search-panel]');
      if (!panel) return;
      panel.hidden = !panel.hidden;
      if (!panel.hidden) { var input = $('input[type="search"]', panel); if (input) input.focus(); }
      return;
    }

    // Accordion
    var accBtn = t.closest('[data-accordion-toggle]');
    if (accBtn) {
      var list = accBtn.closest('[data-accordion]');
      var item = accBtn.parentElement;
      var willOpen = accBtn.getAttribute('aria-expanded') !== 'true';
      if (list) {
        $$('[data-accordion-toggle]', list).forEach(function (b) {
          b.setAttribute('aria-expanded', 'false');
          var s = $('.faq__sign', b); if (s) s.textContent = '+';
          var a = b.nextElementSibling; if (a) a.hidden = true;
        });
      }
      if (willOpen) {
        accBtn.setAttribute('aria-expanded', 'true');
        var sign = $('.faq__sign', accBtn); if (sign) sign.textContent = '−';
        var ans = accBtn.nextElementSibling; if (ans) ans.hidden = false;
      }
      return;
    }

    // Reviews: show all
    var more = t.closest('[data-reviews-more]');
    if (more) {
      var wrap = more.closest('[data-reviews]');
      $$('.review.is-extra', wrap).forEach(function (r) { r.hidden = false; });
      wrap.classList.add('is-expanded');
      more.hidden = true;
      return;
    }

    // Scroll to
    var scrollTo = t.closest('[data-scroll-to]');
    if (scrollTo) {
      var dest = $(scrollTo.dataset.scrollTo);
      if (dest) dest.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }

    // Back arrow on mobile PDP
    var back = t.closest('[data-history-back]');
    if (back && document.referrer && document.referrer.indexOf(window.location.host) !== -1 && window.history.length > 1) {
      e.preventDefault();
      window.history.back();
      return;
    }

    // Login: recover password toggle
    if (t.closest('[data-recover-toggle]')) {
      e.preventDefault();
      var lp = $('[data-login-panel]'); var rp = $('[data-recover-panel]');
      if (lp && rp) { lp.hidden = !lp.hidden; rp.hidden = !rp.hidden; }
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var d = drawer();
      if (d && d.classList.contains('is-open')) CD.closeCart();
      var sp = $('[data-search-panel]');
      if (sp && !sp.hidden) sp.hidden = true;
    }
  });

  /* ------------------------------------------------------------------ */
  /* Tabs: shop by concern                                               */
  /* ------------------------------------------------------------------ */
  function initConcernTabs() {
    $$('[data-concern-tabs]').forEach(function (root) {
      if (root.dataset.init) return;
      root.dataset.init = '1';
      var tabs = $$('[data-tab]', root);
      function activate(tab) {
        tabs.forEach(function (t) {
          var on = t === tab;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          var panel = $('[data-panel="' + t.dataset.tab + '"]', root);
          if (panel) panel.hidden = !on;
        });
      }
      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () { activate(tab); });
        tab.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
            var n = tabs[(i + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length];
            n.focus(); activate(n);
          }
        });
      });
      // Theme editor: select block -> show its panel
      document.addEventListener('shopify:block:select', function (e) {
        var tab = $('[data-tab="' + e.detail.blockId + '"]', root);
        if (tab) activate(tab);
      });
    });
  }

  /* ------------------------------------------------------------------ */
  /* Collection filter                                                   */
  /* ------------------------------------------------------------------ */
  function initCollectionFilter() {
    var root = $('[data-collection-filter]');
    if (!root || root.dataset.init) return;
    root.dataset.init = '1';
    var grid = $('[data-filter-grid]');
    var count = $('[data-filter-count]', root);
    var tabs = $$('[data-filter]', root);
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function apply(filter) {
      var shown = 0;
      $$('[data-product-card]', grid).forEach(function (card) {
        var tags = (card.dataset.tags || '').split(' ');
        var ok = filter === 'all' || tags.indexOf(filter) !== -1;
        card.classList.toggle('is-filtered-out', !ok);
        if (ok) shown++;
      });
      if (count) count.textContent = pad(shown) + ' of ' + count.dataset.totalLabel + ' products';
      tabs.forEach(function (t) {
        var on = t.dataset.filter === filter;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
    }
    tabs.forEach(function (t) { t.addEventListener('click', function () { apply(t.dataset.filter); }); });
    var params = new URLSearchParams(window.location.search);
    var initial = params.get('concern');
    if (initial && tabs.some(function (t) { return t.dataset.filter === initial; })) apply(initial);
  }

  /* ------------------------------------------------------------------ */
  /* Product page                                                        */
  /* ------------------------------------------------------------------ */
  function initProduct() {
    var root = $('[data-product]');
    if (!root || root.dataset.init) return;
    root.dataset.init = '1';

    // Gallery
    var track = $('[data-gallery-track]', root);
    var counter = $('[data-gallery-counter]', root);
    var thumbs = $$('[data-gallery-thumb]', root);
    var slides = $$('[data-gallery-slide]', root);
    var current = 0;
    function setActive(i) {
      current = i;
      thumbs.forEach(function (t) { t.classList.toggle('is-active', Number(t.dataset.galleryThumb) === i); });
      if (counter) counter.textContent = (i + 1) + ' / ' + slides.length;
    }
    function goTo(i) {
      if (!track) return;
      track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
      setActive(i);
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { goTo(Number(t.dataset.galleryThumb)); }); });
    if (track) {
      var raf;
      track.addEventListener('scroll', function () {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
          if (i !== current) setActive(i);
        });
      }, { passive: true });
    }

    // Quantity + ATC label
    var form = $('[data-product-form]', root);
    if (!form) return;
    var qtyInput = $('[data-qty-input]', form);
    var atc = $('[data-product-atc]', form);
    var atcLabel = atc ? $('[data-atc-label]', atc) : null;
    var idInput = $('[data-variant-input]', form);
    var added = false;
    var sticky = $('[data-sticky-atc-btn]');
    var stickyPrice = $('[data-sticky-price]');

    function qty() { return Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1); }
    function refreshLabel() {
      if (!atc || !atcLabel) return;
      if (atc.dataset.available !== 'true') { atcLabel.textContent = CD.strings.soldOut; return; }
      var total = CD.formatMoney(Number(atc.dataset.price) * qty());
      atcLabel.textContent = (added ? CD.strings.added : CD.strings.addToCart) + ' · ' + total;
    }
    $$('[data-qty-minus],[data-qty-plus]', form).forEach(function (b) {
      b.addEventListener('click', function () {
        var v = qty() + (b.hasAttribute('data-qty-plus') ? 1 : -1);
        qtyInput.value = Math.min(9, Math.max(1, v));
        refreshLabel();
      });
    });

    function addFromForm() {
      return CD.addItems([{ id: Number(idInput.value), quantity: qty() }]);
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!atc || atc.disabled) return;
      atc.disabled = true;
      addFromForm()
        .then(function () {
          added = true;
          refreshLabel();
          if (sticky) sticky.textContent = 'Added to Cart';
          if (CD.settings.openDrawerOnAdd) CD.openCart();
        })
        .catch(function (err) { alert(err.message || CD.strings.error); })
        .then(function () { atc.disabled = atc.dataset.available !== 'true'; });
    });

    if (sticky) {
      sticky.addEventListener('click', function () {
        if (form.requestSubmit) form.requestSubmit(); else atc.click();
      });
    }

    var buyNow = $('[data-buy-now]', root);
    if (buyNow) {
      buyNow.addEventListener('click', function (e) {
        e.preventDefault();
        if (buyNow.disabled) return;
        buyNow.disabled = true;
        addFromForm()
          .then(function () { CD.checkout(buyNow); })
          .catch(function (err) { alert(err.message || CD.strings.error); })
          .then(function () { buyNow.disabled = false; });
      });
    }

    // Variants
    var picker = $('[data-variant-picker]', root);
    if (picker) {
      var variants = [];
      try { variants = JSON.parse($('[data-variants-json]', picker).textContent); } catch (err) {}
      picker.addEventListener('change', function () {
        var selected = $$('fieldset', picker).map(function (fs) {
          var c = $('input:checked', fs); return c ? c.value : null;
        });
        var v = variants.find(function (x) {
          return x.options.every(function (o, i) { return o === selected[i]; });
        });
        if (!v) return;
        idInput.value = v.id;
        atc.dataset.price = v.price;
        atc.dataset.available = v.available ? 'true' : 'false';
        atc.disabled = !v.available;
        if (buyNow) buyNow.disabled = !v.available;
        if (sticky) sticky.disabled = !v.available;
        var p = $('[data-price]', root); if (p) p.textContent = CD.formatMoney(v.price);
        if (stickyPrice) stickyPrice.textContent = CD.formatMoney(v.price);
        var cmp = $('[data-compare]', root), save = $('[data-save]', root);
        var hasCmp = v.compare_at_price && v.compare_at_price > v.price;
        if (cmp) { cmp.hidden = !hasCmp; if (hasCmp) $('[data-compare-value]', cmp).textContent = CD.formatMoney(v.compare_at_price); }
        if (save) { save.hidden = !hasCmp; if (hasCmp) $('[data-save-value]', save).textContent = CD.formatMoney(v.compare_at_price - v.price); }
        added = false;
        refreshLabel();
        if (v.featured_media) {
          var slide = $('[data-media-id="' + v.featured_media.id + '"]', root);
          if (slide) goTo(Number(slide.dataset.gallerySlide));
        }
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      });
    }
  }

  /* ------------------------------------------------------------------ */
  /* Help page: order tracking                                           */
  /* ------------------------------------------------------------------ */
  function initTrackForm() {
    $$('[data-track-form]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var order = (form.order.value || '').replace('#', '').trim();
        var contact = (form.contact.value || '').trim();
        var tpl = form.dataset.trackUrl;
        if (tpl && order) {
          var url = tpl.replace('{order}', encodeURIComponent(order)).replace('{contact}', encodeURIComponent(contact));
          window.open(url, '_blank', 'noopener');
        }
        var s = $('[data-track-status]', form);
        if (s) s.hidden = false;
      });
    });
  }

  /* ------------------------------------------------------------------ */
  /* Boot                                                                */
  /* ------------------------------------------------------------------ */
  function init() {
    initConcernTabs();
    initCollectionFilter();
    initProduct();
    initTrackForm();
    syncAddedStates();
    if (window.location.hash === '#recover') {
      var lp = $('[data-login-panel]'); var rp = $('[data-recover-panel]');
      if (lp && rp) { lp.hidden = true; rp.hidden = false; }
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Re-init when sections are edited in the theme editor
  document.addEventListener('shopify:section:load', function () {
    initConcernTabs();
    initCollectionFilter();
    initProduct();
  });
})();
